<template>
  <div id="app">
    <notifications group="main" />
    <a-layout id="components-layout-demo-top" class="layout">
      <a-layout-header :key="currentRoute" :style="{background: '#f0f2f5'}">
        <div class="logo">
          <img src="./assets/brand/Logo.png" />
        </div>
        <a-menu theme="light" mode="horizontal" :defaultSelectedKeys="[currentRoute]" :style="{ lineHeight: '64px' }">
          <a-menu-item key="home">
            <router-link to="/">Home</router-link>
          </a-menu-item>
          <a-menu-item key="about">
            <router-link to="/about">About</router-link>
          </a-menu-item>
          <a-menu-item v-show="$store.state.loggedIn" key="dashboard">
            <router-link to="/dashboard">Dashboard</router-link>
          </a-menu-item>
          <a-menu-item v-show="!$store.state.loggedIn" key="login">
            <router-link to="/login">Login</router-link>
          </a-menu-item>
        </a-menu>
      </a-layout-header>
      <a-layout-content style="padding: 4px 10px">
        <div :style="{ background: '#fff', height: 0, minHeight: '280px' }">
          <transition name="fade" mode="out-in">
            <router-view />
          </transition>
        </div>
      </a-layout-content>
      <a-layout-footer style="text-align: center">
        Do This With Me ©2018 Created by <a href="http://webwaffle.com" target="_blank">Web Waffle LLC.</a>
      </a-layout-footer>
    </a-layout>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        currentRoute: this.$route.name || ""
      };
    },
    watch: {
      "$route.name": function (val) {
        this.currentRoute = val;
        console.log('val');
        console.log(val);
      }
    }
  };
</script>

<style lang="less">
  .logo {
    float: left;

    img {
      width: 220px;
      margin-left: 20px;
      margin-right: 20px;
    }
  }
</style>